import React from 'react';
import PropTypes from 'prop-types';
import { formatters } from 'common';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import messages from './messages';
import DefListColumn from '../DefListColumn';
import DefSubListItem from '../DefSubList';
import getFedWireValue from './utils/getFedWireValue';

const TransferPanelWireDetails = ({
  ctsId,
  bankConfirmation,
  payor,
  payorAddress,
  beneficiary,
  beneficiaryAddress,
  destination,
  destinationAddress,
  furtherCreditTo,
  showAllFields,
}) => (
  <div className={styles.rightPane}>
    {showAllFields && ctsId && <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.ctsId} />}
      data={ctsId}
      dataTestHandle="wireDetails__ctsId"
    />}
    {bankConfirmation && bankConfirmation.id && <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.fedWire} />}
      data={getFedWireValue(bankConfirmation.id, bankConfirmation.type)}
      dataTestHandle="wireDetails__fedWire"
    />}
    {payor &&
      <div className={styles.listContainer} data-test-handle="wireDetails__payor">
        <div className={styles.listTitle}><FormattedMessage {...messages.payor} /></div>
        <div className={styles.subList}>
          {payor.name &&
            <DefSubListItem
              title="Name"
              data={formatters.formatTitleCase(payor.name)}
              dataTestHandle="wireDetails__payorName"
            />
          }
          {payorAddress &&
            <DefSubListItem
              title="Address"
              data={payorAddress}
              dataTestHandle="wireDetails__payorAddress"
            />
          }
        </div>
      </div>
    }
    {beneficiary &&
      <div className={styles.listContainer} data-test-handle="wireDetails__beneficiary">
        <div className={styles.listTitle}><FormattedMessage {...messages.beneficiary} /></div>
        <div className={styles.subList}>
          {beneficiary.name &&
            <DefSubListItem
              title="Name"
              data={formatters.formatTitleCase(beneficiary.name)}
              dataTestHandle="wireDetails__beneficiaryName"
            />
          }
          {beneficiaryAddress &&
            <DefSubListItem
              title="Address"
              data={beneficiaryAddress}
              dataTestHandle="wireDetails__beneficiaryAddress"
            />
          }
        </div>
      </div>
    }
    {destination &&
      <div className={styles.listContainer} data-test-handle="wireDetails__destination">
        <div className={styles.listTitle}><FormattedMessage {...messages.destination} /></div>
        <div className={styles.subList}>
          {destination.accountName &&
            <DefSubListItem
              title="Name"
              data={formatters.formatTitleCase(destination.accountName)}
              dataTestHandle="wireDetails__destinationName"
            />
          }
          {destination.account &&
            <DefSubListItem
              title="Account"
              data={destination.account}
              dataTestHandle="wireDetails__destinationAccount"
            />
          }
          {destination.bankName &&
            <DefSubListItem
              title="Bank Name"
              data={destination.bankName}
              dataTestHandle="wireDetails__destinationBankName"
            />
          }
          {destination.bankIdentifier &&
            destination.bankIdentifier.id &&
            destination.bankIdentifier.type &&
            <DefSubListItem
              title="BIC/ABA"
              data={`${destination.bankIdentifier.id} (${destination.bankIdentifier.type})`}
              dataTestHandle="wireDetails__destinationBankIdentifier"
            />
          }
          {destinationAddress &&
            <DefSubListItem
              title="Address"
              data={destinationAddress}
              dataTestHandle="wireDetails__destinationAddress"
            />
          }
        </div>
      </div>
    }
    {furtherCreditTo &&
      <div className={styles.listContainer} data-test-handle="wireDetails__furtherCreditTo">
        <div className={styles.listTitle}><FormattedMessage {...messages.furtherCreditTo} /></div>
        <div className={styles.subList}>
          {furtherCreditTo.name &&
            <DefSubListItem
              title="Name"
              data={formatters.formatTitleCase(furtherCreditTo.name)}
              dataTestHandle="wireDetails__furtherCreditToName"
            />
          }
          {furtherCreditTo.account &&
            <DefSubListItem
              title="Account"
              data={furtherCreditTo.account}
              dataTestHandle="wireDetails__furtherCreditToAccount"
            />
          }
        </div>
      </div>
    }
  </div>
);

TransferPanelWireDetails.propTypes = {
  ctsId: PropTypes.number,
  bankConfirmation: {
    id: PropTypes.string,
    type: PropTypes.string,
  },
  payor: PropTypes.object,
  payorAddress: PropTypes.string,
  beneficiary: PropTypes.object,
  beneficiaryAddress: PropTypes.string,
  destination: PropTypes.object,
  destinationAddress: PropTypes.string,
  furtherCreditTo: PropTypes.object,
  showAllFields: PropTypes.bool.isRequired,
};

TransferPanelWireDetails.defaultProps = {
  ctsId: null,
  bankConfirmation: null,
  payor: null,
  payorAddress: '',
  beneficiary: null,
  beneficiaryAddress: '',
  destination: null,
  destinationAddress: '',
  furtherCreditTo: null,
};

export default TransferPanelWireDetails;



// WEBPACK FOOTER //
// ./src/components/TransferPanelWireDetails/index.js